import { FLOWER_MANIFEST_KEY, validateFlowerManifest } from './flowerComposition';
import { NOODLE_MANIFEST_KEY, validateNoodleManifest } from './noodleSetEvidence';
const LEGAL = /exclusion|excluded|child_slice_scope|part_routing_stage|part_target_heading|sports_footwear_status|sports_footwear_type|essential_character|residual|legal_|explicit_heading|confirmed_scope|statutory|chapter\d+_(?:article_family|subheading_family)|hs4|hs6|hsk|heading_code|^reviewed_chapter_scope$|^article_family$|^subheading_family$|^domestic_subdivision$|^article_role$|^item_role$/i;
const LEGAL_TEXT = /법정|본질적 특성|제외 (?:규정|조항|여부)|형제.*배제|제\s*\d{2,4}.*(?:호|류).*해당|통칙|법적|소호.*배제|대상 기계의.*호|주기능 호|부분품 대상 호/;
const OBSERVABLE_ROUTES = new Set(['chapter20_tomato_product_route', 'chapter23_heading2301_product_route', 'chapter25_heading2528_product_route', 'chapter24_nicotine_application_route']);
export const isLegalDecisionKey = (key) => {
  const value = String(key || '');
  return !OBSERVABLE_ROUTES.has(value) && (LEGAL.test(value) || /_route(?:_.*)?$|^chapter\d+_subheading_parent_group$|_nesi_status$|^chapter\d+_note\d+_.*$|^chapter20_domestic_juice_(?:base|fruit_kind)$/.test(value));
};
export const isLegalDecisionText = text => LEGAL_TEXT.test(String(text || ''));
export const isProductQuestion = (q) => q && typeof q === 'object' && !isLegalDecisionKey(q.fact_key || q.key)
  && !LEGAL_TEXT.test(q.prompt_ko || q.question || q.label || '');
export function productFactsOnly(facts) {
  return Object.fromEntries(Object.entries(facts || {}).filter(([k, v]) => !isLegalDecisionKey(k) && !k.startsWith('_') && v !== '' && v != null
    && (typeof v !== 'object' || (k === FLOWER_MANIFEST_KEY && validateFlowerManifest(v).valid)
      || (k === NOODLE_MANIFEST_KEY && validateNoodleManifest(v).valid))));
}
export function productDialogue(tree = {}) {
  if (tree.product_fact_dialogue) {
    const d = tree.product_fact_dialogue;
    // Also protect previously stored server responses containing questions and a document request.
    if (d.document_requests?.length) return {...d, status:'needs_documents',title:'여기서 질문을 멈췄습니다',
      description:'모르는 내용은 추측하지 않아도 됩니다. 지금까지의 답변은 저장했습니다. 아래 자료를 확인한 뒤 원할 때 이어서 진행하세요.',
      questions:[],deferred_questions:[]};
    const questions=(d.questions || []).filter(isProductQuestion);
    if(d.status==='needs_product_facts' && (d.questions || []).length && !questions.length)
      return {...d,status:'rule_coverage_required',title:'자동 판단 규칙의 추가 검토가 필요합니다',
        description:'남은 법적 판단은 PROVE가 검토해야 합니다. 확인한 상품 정보는 보존했습니다.',questions:[],
        deferred_questions:(d.deferred_questions || []).filter(isProductQuestion)};
    return { ...d, questions };
  }
  const raw = Array.isArray(tree.questions) ? tree.questions : [];
  const safe = raw.filter(isProductQuestion).filter(q => !q.deferred);
  const blocked = raw.some(q => !isProductQuestion(q));
  return {
    status: safe.length ? 'needs_product_facts' : blocked ? 'rule_coverage_required' : 'candidate_ready',
    title: safe.length ? '상품 정보를 확인해 주세요' : blocked ? '자동 판단 규칙의 추가 검토가 필요합니다' : '분류 계산 결과',
    description: blocked ? '남은 법적 판단은 PROVE가 검토해야 합니다. 사용자가 제외 여부나 분류번호를 대신 결정하지 않습니다.' : '',
    questions: safe.slice(0, 1), deferred_questions: safe.slice(1), document_requests: [],
  };
}
